import uuid from 'uuid/v4';
import addToShoppingCartAsync from './addToShoppingCartAsync';
import * as Constant from '../../../constant';

export default tariffSimulation => async (dispatch) => {
  const { blNo, totalPayment } = tariffSimulation;
  const itemId = uuid();

  await dispatch(addToShoppingCartAsync(
    itemId,
    blNo,
    Constant.CART_SERVICE_NAME_IMPORT,
    totalPayment,
    tariffSimulation,
  ));
};
